module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/parents/parents.component.css
// module id = ./src/app/parents/parents.component.css
// module chunks = main